import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ATTACHMENT_UPLOAD_STATUS } from '../../../../../core/constants/attachments-upload-statue.enum';
import { GlobalConstants } from '../../../../../core/constants/globals';
import { SNACKBAR_ALERT_TYPES } from '../../../../../core/constants/snackbar-alert-types.enum';
import { AttachmentFile } from '../../../../../core/models/attachment-file.model';
import { Attachment } from '../../../../../core/models/attachment.model';
import { ApiRequestService } from '../../../../../core/services/api-request.service';
import { RequestViewService } from '../../../../../core/services/request-view.service';
import { SnackbarAlertService } from '../../../../../core/services/snackbar-alert.service';

@Component({
    selector: 'app-attachment-item',
    templateUrl: './attachment-item.component.html',
    styleUrls: ['./attachment-item.component.css']
})
export class AttachmentItemComponent implements OnInit {
    @Input() attachment: Attachment | AttachmentFile;
    @Input() requestId: number;
    @Input() reportId: number;
    @Input() action: string;
    @Input() moduleName: string = '';
    @Input() commentId;
    @Input() viewType;
    showLoader = false;
    downloadAttachment = GlobalConstants.DOWNLOAD_ATTACHMENT_ACTION;
    addAttachment = GlobalConstants.ADD_ATTACHMENT_ACTION;
    errorSnackbarAlert = SNACKBAR_ALERT_TYPES.ERROR;
    uploadingStatus = ATTACHMENT_UPLOAD_STATUS.UPLOADING;
    myDialogRef: DialogRef<unknown, any>;
    url: string;
    extension: string;
    constructor(
        private apiRequestService: ApiRequestService,
        private requestsService: RequestViewService,
        private snackbarAlertService: SnackbarAlertService,
        private dialog: Dialog,
        public sanitizer: DomSanitizer
    ) {}

    ngOnInit(): void {}
    downloadFile() {
        this.showLoader = true;
        this.apiRequestService.downloadAttachment(this.moduleName, this.requestId, this.attachment.id, this.commentId, this.viewType).subscribe({
            next: response => {
                if (response) {
                    const blob = new Blob([response.body], { type: response.body.type });
                    const url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = this.attachment.name;
                    a.click();
                } else {
                    console.log('error');
                }
                this.showLoader = false;
            },
            complete: () => {
                this.showLoader = false;
            },

            error: (error: HttpErrorResponse) => {
                this.showLoader = false;
                this.snackbarAlertService.openSnackBar('downloadAttachmentErrorMessage', this.errorSnackbarAlert);
            }
        });

        // (
        //     (response: any) => {
        //     if(response){
        //     const blob = new Blob([response.body], { type: response.body.type });
        //     const url = window.URL.createObjectURL(blob);
        //     let a = document.createElement('a');
        //     a.href = url;
        //     a.download = 'test download';
        //     a.click();
        //     this.showLoader = false;}
        //     else{
        //         console.log("error")
        //     }

        // }
        // ,
        // error => {
        //        this.showLoader = false;
        //    this.snackbarAlertService.openSnackBar('downloadAttachmentErrorMessage', this.errorSnackbarAlert);
        //     });
    }

    downloadFileFromObjectStore(downloadUrl: string, filename: string, contentType: string) {
        this.apiRequestService.downloadFileFromObjectStore(downloadUrl, contentType).subscribe((response: any) => {
            const blob = new Blob([response.body], { type: response.body.type });
            const url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click(); // start download
            this.showLoader = false;
        });
    }

    removeAttachment(attachmentToRemove: AttachmentFile | Attachment) {
        this.requestsService.removeAttachment.next(attachmentToRemove);
    }
    getBase64File() {
        this.apiRequestService.getFilebase64(this.requestId, this.attachment.id, this.moduleName, this.viewType).subscribe({
            next: response => {
                if (response) {
                    const url = response.data?.base64Code;
                    this.extension = this.getBase64FileExtension(url);
                    if (this.extension === 'application/pdf') {
                        const blob = this.base64toBlob(`data:application/pdf;base64,${url}`);
                        this.url = URL.createObjectURL(blob);
                    } else {
                        this.url = url;
                    }
                } else {
                    console.log('error');
                }
                this.showLoader = false;
            },
            complete: () => {
                this.showLoader = false;
            },
            error: (error: HttpErrorResponse) => {
                this.showLoader = false;
            }
        });
    }

    base64toBlob(data: string) {
        // Cut the prefix `data:application/pdf;base64` from the raw base 64
        const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);

        const bytes = atob(base64WithoutPrefix);
        let length = bytes.length;
        let out = new Uint8Array(length);

        while (length--) {
            out[length] = bytes.charCodeAt(length);
        }

        return new Blob([out], { type: 'application/pdf' });
    }
    getBase64FileExtension(base64String: string) {
        switch (base64String.substring(0, 1)) {
            case '/':
                return 'image/jpeg';
            case 'i':
                return 'image/png';
            case 'R':
                return 'image/gif';
            case 'J':
                return 'application/pdf';
            default:
                return 'unknown';
        }
    }
    //data:image/png;base64,
    openDialog(template: TemplateRef<unknown>) {
        this.getBase64File();
        //test by local image
        // this.url = 'iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=='
        // this.extension = this.getBase64FileExtension(this.url);
        if (this.action === this.downloadAttachment) {
            this.myDialogRef = this.dialog.open(template);
        }
    }
}
